import { render, staticRenderFns } from "./PacketListExtended.vue?vue&type=template&id=0362436a&scoped=true&"
import script from "./PacketListExtended.vue?vue&type=script&lang=js&"
export * from "./PacketListExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0362436a",
  null
  
)

export default component.exports